import { browserLogger } from '@newfront-insurance/dd-rum';

import { AuthOptions, type AuthState } from '../types';

export function createGraphStorage() {
  const STORAGE_KEY = 'graph-oauth-state';

  const saveAuthState = (state: AuthState): void => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      browserLogger.warn('[MS Graph Auth] Failed to save auth state', undefined, error as Error);
    }
  };

  const loadAuthState = (): AuthState => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        return { state: AuthOptions.LOGGED_OUT };
      }

      const parsed = JSON.parse(stored) as AuthState;

      // If last state is ERROR or missing userInfo, return LOGGED_OUT
      if (parsed.state === AuthOptions.ERROR || !parsed.userInfo) {
        return { state: AuthOptions.LOGGED_OUT };
      }

      return parsed;
    } catch (error) {
      browserLogger.warn('[MS Graph Auth] Failed to load auth state', undefined, error as Error);
      return { state: AuthOptions.LOGGED_OUT };
    }
  };

  const clearAuthState = (): void => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      browserLogger.warn('[MS Graph Auth] Failed to clear auth state', undefined, error as Error);
    }
  };

  return { saveAuthState, loadAuthState, clearAuthState };
}
